export default {
  login: {
    title: '마이페이지 로그인',
    double_check_text: '입력하신 정보는 올바르지 않습니다. 다시 확인해 주세요.',
    id_email: 'ID/이메일 주소',
    password: '패스워드',
    password_display: '패스워드 표시',
    password_no_display: '패스워드 미표시',
    login: '로그인',
    keep_login_text: '로그인 정보 유지하기',
    forgot_password_text: '패스워드를 분실하신 분은 여기서',
    contact_us: '미등록인 분은 문의하기에서',
    asuene_service_outline: 'CO2 가시화 클라우드 서비스 ‘ASUENE’',
    // asuene_lca_service_outline: '',
    asuene_career_service_outline: 'GX・ESG 인재 특화형 이직 플랫폼 ‘ASUENE CAREER’',
    corporate_page: '기업 HP',
    // cross_use: {
    //   title: '',
    //   asuene_product: {
    //     banner_title: '',
    //     flag_text: '',
    //     left_btn_label: '',
    //     left_btn_link: '',
    //     right_btn_label: '',
    //     right_btn_link: '',
    //   },
    //   footer_note: ''
    // }
  },
}
